<mat-card appearance="outlined">
  <mat-card-content>
    <mat-list>
      @for (email of emails; track email; let idx = $index) {
        <mat-list-item>
          <div matListItemTitle>
            @if (email.type === 'secondary') {
              <span i18n>Secondary email:</span>
            }
            @if (email.type === 'primary') {
              <span i18n>Primary email:</span>
            }
            &nbsp;<span>{{ email.email }}</span>
          </div>
          <div matListItemMeta>
            <button mat-icon-button color="primary" (click)="onClick(idx)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="onRemove(idx)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </mat-card-content>
</mat-card>
